import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CancelContractMutation } from "../graphql/mutations";
import type {
  CancelContractMutationType,
  CancelContractMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useCancelContractMutation = (
  options?: MutationHookOptions<
    CancelContractMutationType,
    CancelContractMutationVariablesType
  >
) => {
  return useMutation<
    CancelContractMutationType,
    CancelContractMutationVariablesType
  >(CancelContractMutation, options);
};
